import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7dfa39ysx: FaireProductEntity = {
  token: "p_m7dfa39ysx",
  type: "product",
  name: "evergreen Christmas assorted notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c6fe32799c5b1cc4992dac5b304e23a3d2f8a176f7a76fe488b70abc1e9cd69d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5d49731996600891a3b13979da03a95c81034d602bf41085eeb6af02f195898.jpeg",
    "https://cdn.faire.com/fastly/869bcf8e2fca4431d14eee8387ef9096c79b7ccfafe410465b81509a43902b41.jpeg",
    "https://cdn.faire.com/fastly/9fcc592c031f06c8f1ee8d1311f2232478935dd9bfd7be76d0dc21f13db09d95.jpeg",
    "https://cdn.faire.com/fastly/f2a5cae728c5b49144ac32f66aa42fe82e30ef3b6a13b59a4351caee5b7055e1.jpeg",
    "https://cdn.faire.com/fastly/cc975e441d00ce5b707069ff93b9de4e7a33d662ae7b65e791e7685975d3ae32.jpeg",
    "https://cdn.faire.com/fastly/307c8cff32513fce016600553c9b6bb86e5a7253755761b567f47db16ed19dc4.jpeg",
    "https://cdn.faire.com/fastly/405e481ecd294f524e8a67d15e60b831ff05f54be6fe84443e51cd24a61f50cc.jpeg",
  ],
  priceDollars: 8,
  description:
    'The assorted set of evergreen notecards are blank on the inside with charming watercolor illustrations of a chickadee, pinecone, reindeer and potted tree on the front. They bring a touch of delight to your Christmas cards, hostess gifts, thank you notes, housewarming gifts, get-well wishes, and more.\n\nDetails:\n\n- set of eight folded cards + envelopes, two of each illustration\n- blank inside\n- 5.5" x 4.25"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n\n\n',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:14.085Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
